import { router } from '@inertiajs/vue3'

import { $t } from '../shared/i18n'
import { error } from '../shared/notifications'

export function useServerExceptions() {
  const init = () => {
    router.on('invalid', (event) => {
      const status = event.detail.response.status
      if (status === 419) {
        error('Page expired. Please try again.')
      }

      if (status === 403) {
        error($t('You are no longer authorized to perform this action.'))
      }

      if (status === 401) {
        error('Session expired.')
      }

      if ([401, 403, 419].includes(status)) {
        event.preventDefault()
        router.reload()
        return
      }
    })
  }

  init()
}
